import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

const selectInvestmentsState = (state: RootState) => state.investments;

export const selectInvestments = createSelector(
  selectInvestmentsState,
  (investmentsState) => investmentsState
);
